/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : ADDONS PAGE : STYLES --------------- ++++++++++ */
export default theme => ({
  commentingaddonssection: {
    '& .expandablesection': {
      boxShadow: 'none',
      margin: `${pxToEm(8)} 0`
    },
    '& .collapsable': {
      '& .innerWrap': {
        padding: 0
      },
      '&.opened': {
        overflow: 'visible',
        '& .innerWrap': {
          padding: pxToEm(8)
        }
      }
    },
  }
});
